export const IS_LOADING_TICKETS = "IS_LOADING_TICKETS";
export const GET_TICKETS_SUCCESS = "GET_TICKETS_SUCCESS";
export const GET_TICKETS_FALED = "GET_TICKETS_FALED";

export const UPDATE_TICKETS_SUCCESS = "UPDATE_TICKETS_SUCCESS";
export const UPDATE_TICKETS_FALED = "UPDATE_TICKETS_FALED";


export const IS_LOADING_READ = "IS_LOADING_READ";
export const GET_READ_SUCCESS = "GET_READ_SUCCESS";
export const GET_READ_FALED = "GET_READ_FALED";
